import styled from 'styled-components';

export const Wrapper = styled.footer`
  background: #000;
  padding: 30px 15px;
`;

export const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  color: #fff;
  justify-content: space-between;
  flex-direction: column;
  @media(max-width: 1100px){
    flex-direction: column-reverse;
  }
  .logo-footer {
    width: 100px;
    margin-bottom: 20px;
    @media(max-width: 1100px){
      margin-right: 0;
      margin-top: 20px;
      width: 100px;
    }
  }
  aside {
    width: 100%;
    text-align: right;
    @media(max-width: 1100px){
      text-align: center;
    }
    h4 {
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 15px;
      letter-spacing: 0.01em;
      text-align: center;
      color: #fff;
      margin-bottom: 20px;
    }
    ul {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 15px;
      letter-spacing: 0.01em;
      line-height: initial;
      @media(max-width: 1100px){
        justify-content: center;
        font-size: 18px;
      }
      @media(max-width: 600px){
        flex-wrap: wrap;
      }
      li {
        margin: 0 15px;
        @media(max-width: 1100px){
          margin: 0 5px;
        }
        a {
          color: #fff;
        }
      }
    }
  }
`;
